import React from "react";

const DocumentIcon = ({ iconClass, color }) => {
  return (
    <svg
      width={20}
      height={21}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={iconClass}
      preserveAspectRatio="xMidYMid meet"
    >
      <path
        d="M17.5 6.33341V14.6667C17.5 17.1667 16.25 18.8334 13.3333 18.8334H6.66667C3.75 18.8334 2.5 17.1667 2.5 14.6667V6.33341C2.5 3.83341 3.75 2.16675 6.66667 2.16675H13.3333C16.25 2.16675 17.5 3.83341 17.5 6.33341Z"
        stroke={color}
        strokeOpacity="0.8"
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0835 4.25V5.91667C12.0835 6.83333 12.8335 7.58333 13.7502 7.58333H15.4168"
        stroke={color}
        strokeOpacity="0.8"
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.6665 11.3333H9.99984"
        stroke={color}
        strokeOpacity="0.8"
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.6665 14.6667H13.3332"
        stroke={color}
        strokeOpacity="0.8"
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DocumentIcon;
